export default __webpack_public_path__ + "assembly21205032.png";